import { observer } from 'mobx-react'
import React, { useState } from 'react'
import { APIStatus } from '@flowwai-frontend/shared/api-common'
import cn from 'classnames'

import { ReactBaseModalContainer } from '@flowwai-frontend/shared/common-components'
import { isAPIFetching } from '@flowwai-frontend/shared/utils/common'
import { XCloseIcon } from '@flowwai-frontend/design-system/icons'

import { commonTheme } from '../../themes'
import './styles.css'

interface ConfirmationModalProps {
   isOpen?: boolean
   apiStatus: APIStatus
   onCloseModal?: () => void
   renderConfirmationCard: () => React.ReactElement | string
   hideCloseIcon?: boolean
   containerClassName?: string
   modalContainerClassName?: string
   shouldReturnFocusAfterClose?: boolean
}

const ConfirmationModal = (
   props: ConfirmationModalProps
): React.ReactElement | null => {
   const {
      isOpen,
      onCloseModal: onCloseModalPropFunc,
      renderConfirmationCard,
      apiStatus,
      hideCloseIcon = false,
      modalContainerClassName,
      shouldReturnFocusAfterClose = true
   } = props

   const [isModalOpen, setIsModalOpen] = useState(false)
   const isLoading = isAPIFetching(apiStatus)

   const onCloseModal = () => {
      if (!isLoading) {
         setIsModalOpen(false)
         onCloseModalPropFunc && onCloseModalPropFunc()
      }
   }

   const confirmationUITheme = commonTheme.confirmationUI

   return (
      <ReactBaseModalContainer
         onClickCloseIcon={onCloseModal}
         isOpen={isModalOpen || isOpen}
         className={cn(
            `crm-web-common-delete-board-modal `,
            modalContainerClassName
         )}
         overlayClassName={cn(
            'crm-web-common-delete-board-overlay',
            props.containerClassName
         )}
         closeIconClass={'crm-web-common-delete-board-modal-close-icon'}
         hideCloseIcon={hideCloseIcon}
         customCloseIcon={() => (
            <XCloseIcon
               height={24}
               width={24}
               fill={confirmationUITheme.closeIconColor}
            />
         )}
         shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
      >
         {renderConfirmationCard()}
      </ReactBaseModalContainer>
   )
}

export default observer(ConfirmationModal)
